// src/Routes/Prompts/UsePrompt.tsx
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GoogleAnalyticsContext } from "../../Hooks/GoogleAnalyticsContext";
import { useAuthenticatedFetch } from "../../Hooks/useFetch";
import config from "../../config";
import PromptUsage from "../../Components/HighLevelComponents/UserPromptManagement/components/PromptUsage";
import PromptResult from "../../Components/HighLevelComponents/UserPromptManagement/components/PromptResult";
import { Prompt } from "../../Components/HighLevelComponents/UserPromptManagement/components/types";
import SidebarLayout from "../../Components/Layout/SidebarLayout";
import { HashLoader } from "react-spinners";
import { useFirebaseAuth } from "../../Hooks/FirebaseAuth";

const UsePrompt: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [prompt, setPrompt] = useState<Prompt | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [promptResult, setPromptResult] = useState<any>(null);
  const navigate = useNavigate();
  const { logEvent } = useContext(GoogleAnalyticsContext);
  const user = useFirebaseAuth();

  const { res: promptRes, callAPI: fetchPrompt } = useAuthenticatedFetch({
    url: `${config.API_URI}/api/prompt/${id}`,
    method: "GET",
  });

  useEffect(() => {
    if (user) {
      fetchPrompt();
      logEvent("CustomToolAction", "UseToolView", `tool_${id}`);
    }
  }, [id, user]);

  useEffect(() => {
    if (promptRes.statusCode === 200 && promptRes.data?.prompt) {
      setPrompt(promptRes.data.prompt);
      setIsLoading(false);
    } else if (promptRes.statusCode === 404) {
      navigate("/custom-tools");
    }
  }, [promptRes]);

  const handleResult = (result: any) => {
    setPromptResult(result);
    logEvent("CustomToolAction", "ViewResult", `tool_${id}`);
  };

  const handleBack = () => {
    navigate("/custom-tools");
  };

  if (isLoading) {
    return (
      <SidebarLayout>
        <div className="flex justify-center items-center h-64">
          <HashLoader size={40} color="#FFC60B" />
        </div>
      </SidebarLayout>
    );
  }

  return (
    <SidebarLayout>
      <div className="max-w-6xl mx-auto px-4">
        <div className="space-y-6">
          {prompt && (
            <PromptUsage
              prompt={prompt}
              onResult={handleResult}
              onBack={handleBack}
            />
          )}
          {promptResult && prompt && (
            <PromptResult outputs={prompt.outputs} result={promptResult} />
          )}
        </div>
      </div>
    </SidebarLayout>
  );
};

export default UsePrompt;
